import React, { ReactElement } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
//
import Testimonials from "@organisms/Testimonials/Testimonials";
import HowItWorks from "@templates/HomePage/HomePage/HowItWorks";
import InuuaIsMuchMoreThanAHousePlan from "@templates/HomePage/HomePage/InuuaIsMuchMoreThanAHousePlan";
import SaveUpTo40Percent from "@templates/HomePage/HomePage/SaveUpTo40Percent";
import LazyImage from "@molecules/layout/Images/LazyImage";
import InuuaPartners from "@organisms/Common/InuuaPartners";
import { KENYAN_PLAN_CATEGORIES } from "@src/settings";

//
const checkPoints = [
    "Architectural Drawings",
    "Free Project Management Tools on your Phone",
    "Bills of Materials and Labour",
    "All Engineering Drawings",
];

function HousePlans() {
    const router = useRouter();
    return (
        <section
            id="house-types"
            className="section section-lg bg-soft pt-lg-6"
        >
            <div className="container">
                {/* <------------------------------------- checkpoints  ------------------------------------> */}
                <div className="row justify-content-left mb-lg-5 mb-md-5">
                    <h2 className="h2 font-weight-bold mb-4 pmx-5">
                        The beautiful house plans include:
                    </h2>

                    <div className="col-12">
                        <div className="pr-0 row flex-wrap d-flex ml-0 mb-3">
                            {checkPoints.map((point, index) => (
                                <div
                                    className="img-details shadow-sm bg-white p-3 mr-3 mb-2"
                                    key={index}
                                >
                                    <span className="mr-2">
                                        <i className="fas fa-check-circle text-dark"></i>
                                    </span>
                                    <span className="font-weight-bold">
                                        {point}
                                    </span>
                                </div>
                            ))}
                        </div>
                        <div className="">
                            <h3 className="h3 font-weight-bold mb-4 pmx-5">
                                all for{" "}
                                <span className="plan-price">KSh. 20,000!</span>
                            </h3>
                        </div>
                    </div>
                </div>
                {/* <------------------------------------- end checkpoints  ------------------------------------> */}

                {/* <------------------------------------- house types  ------------------------------------> */}
                <div className="row flex-wrap">
                    {KENYAN_PLAN_CATEGORIES.map((houseType, index) => (
                        <div
                            className="col-12 col-lg-4 mb-5 d-flex"
                            key={index}
                        >
                            <div className="card shadow-soft border-light h-100">
                                <div className="card-header p-0 card-header-img">
                                    {/* @ts-ignore */}
                                    <LazyImage
                                        src={`/${houseType.image}`}
                                        // wrapperClassName="card-img-top rounded-top"
                                        className="card-img-top rounded-top"
                                        alt={`Inuua ${houseType.name} House Plans, Architectural Drawings, Engineering Drawings and Bills of Materials & Labour`}
                                    />

                                    <div className="img-details shadow-sm">
                                        <div className="pl-4 pt-2">
                                            <span className="h6">
                                                {houseType.name}
                                            </span>
                                        </div>
                                        <div className="pl-4">
                                            <ul className="list-inline">
                                                <li className="list-inline-item">
                                                    <i className="fas fa-bed font-small font-weight-bold"></i>
                                                    &nbsp;
                                                    <span>
                                                        <small>
                                                            {houseType.beds}
                                                        </small>
                                                    </span>
                                                </li>
                                                {houseType.showers &&
                                                houseType.showers.length > 0 ? (
                                                    <li className="list-inline-item">
                                                        <i className="fas fa-bath font-small font-weight-bold"></i>
                                                        &nbsp;
                                                        <span>
                                                            <small>
                                                                {
                                                                    houseType.showers
                                                                }
                                                            </small>
                                                        </span>
                                                    </li>
                                                ) : null}
                                                <li className="list-inline-item">
                                                    <i className="fa fa-money font-small font-weight-bold"></i>
                                                    &nbsp;
                                                    <span>
                                                        <small>
                                                            {houseType.price}
                                                        </small>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <ul className="list-group d-flex justify-content-center mb-4">
                                        {houseType.points.map((point, idx) => (
                                            <li
                                                className="list-group-item d-flex pl-0 pb-1 pt-0"
                                                key={idx}
                                            >
                                                <span className="mr-2">
                                                    <i className="fas fa-check-circle text-dark"></i>
                                                </span>
                                                {point}
                                            </li>
                                        ))}
                                    </ul>

                                    <Link
                                        href={`${router.asPath}/plan-category/${houseType.slug}`}
                                    >
                                        <a className="analytics-view-plans-link btn btn-dark text-uppercase">
                                            View {houseType.pluralName}
                                        </a>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* <------------------------------------- end house types  ------------------------------------> */}
            </div>
        </section>
    );
}

interface Props {}

function Kenya({}: Props): ReactElement {
    const router = useRouter();
    return (
        <div>
            <section
                id="all-plans-intro"
                className="pt-lg-6 section-header pb-lg-0 mbb-0 bg-white text-dark"
            >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8 col-md-8 text-center">
                            <h1 className="font-size-34 mb-3 d-none d-md-block">
                                Kenyan House Plans
                            </h1>
                            <h1 className="font-size-24 mb-3 d-block d-md-none">
                                Kenyan House Plans
                            </h1>
                            <div className="pt-3">
                                <p className="lead font-size-12 text-muted">
                                    Browse our catalogue for your dream house
                                    plan and turn it into reality
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <hr />
            <HowItWorks />
            <HousePlans />
            <InuuaIsMuchMoreThanAHousePlan />
            <Testimonials />
            <SaveUpTo40Percent />
            <InuuaPartners />
        </div>
    );
}

export default Kenya;
